/*
Aditya 10/03/2022 2698947782 Implemented Draggable dialog box for Delete pop-ups and favourite window
Sai Maheshwar 12/20/2022 2698947782 fixed drag and drop issue
*/

import React, {useContext} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import SelectTabContextProvider from '../../components/SelectTabContext/SelectTabContext';
import CloseIcon from '@material-ui/icons/Close';
import {Box} from '@material-ui/core';
import SettingsForm from './SettingsForm';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: 20,
    color: '#FFF',
    borderBottom: '1px solid #ffffff8a',
    alignItems: 'center',
  },

  closeButton: {
    'position': 'absolute',
    'right': 18,
    'top': 18,
    'color': '#000',
    'width': 20,
    'height': 20,
    'backgroundColor': '#F8F8F8',
    '&:hover, &:focus, &.active': {
      backgroundColor: '#F8F8F8',
      outline: 'none',
    },
  },
  heading: {
    fontSize: 16,
    color: '#fff',
    fontWeight: 500,
    // backgroundColor: 'linear-gradient(#7C7AFC, #7876f7)',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.5rem',
    },
  },
});

// causing issue in drag and drop of children elements
// function PaperComponent(props) {
//   return (
//     <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
//       <Paper {...props} />
//     </Draggable>
//   );
// }

const DialogTitle = withStyles(styles)((props) => {
  const {children, classes, onClose, ...other} = props;
  return (
    <div className="themeColor">
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <div className={classes.heading}>{children}</div>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    </div>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '15px',
    backgroundColor: 'rgb(239 239 239 / 0.75)',
  },
}))(MuiDialogContent);

export default function SettingsDialog({handleModalClose, open}) {
  const {settingsW3, setSettingsW3} = useContext(SelectTabContextProvider);

  const handleClose = () => {
    setSettingsW3(false);
    handleModalClose();
  };

  return (
    <Box>
      <Dialog
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        open={open || settingsW3}
        fullWidth
        maxWidth={'md'}
        // PaperComponent={PaperComponent}
      >
        <DialogTitle onClose={handleClose}>
          Table Settings
        </DialogTitle>
        <div className="settings-theme">
          <DialogContent>
            <SettingsForm handleClose={handleClose} />
          </DialogContent>
        </div>
      </Dialog>
    </Box>
  );
}
